import Bar from "../../../../components/horizontal_bar";
import Button from "../../../../components/button";
import HeaderOne from "../../../../components/headers/header_one";
import HeaderThree from "../../../../components/headers/header_three";
import Text from "../../../../components/paragraph";

import { Element, elements } from "./utils";

const SalesSection = () => {
	const AcronymLetter = ({ number, title, description, color }: Element) => {
		return (
			<div className="flex flex-row items-center w-full">
				<div
					className={`flex items-center justify-center text-white w-16 h-16 rounded-full`}
					style={{ border: `3px solid ${color}` }}
				>
					<span className="text-[47px] p-0 m-0 pb-1 text-black">{number}</span>
				</div>
				<div className="flex flex-col items-start w-full">
					<HeaderThree className={"text-sm-header font-medium md:pl-4 text-left"}>{title}</HeaderThree>
					<Bar color={color} />
					<Text className={"text-regular font-normal md:pl-4 text-left"}>{description}</Text>
				</div>
			</div>
		);
	};

	return (
		<div className={"my-10 flex flex-col items-start md:px-40 w-full px-4 md:text-left text-center"}>
			<HeaderOne>Upgrade Your Vacation Rental Space</HeaderOne>
			<div className={"my-[10px]"}>
				<Text>
					Make your Airbnb listing stand out with my professional design expertise. I understand that the right design can
					greatly impact the success of your Airbnb rental. As a stager and designer, I can help you create a welcoming and
					visually appealing space that will attract more guests and earn you rave reviews.
				</Text>
			</div>
			<HeaderThree>Why Choose My Airbnb Design Service?</HeaderThree>
			<div className={"my-[10px]"}>
				{elements.map((element: Element, index: number) => {
					return (
						<div key={index} className={"my-[10px]"}>
							<AcronymLetter {...element} />
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default SalesSection;
